import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(timezone)
dayjs.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone)

export default dayjs
